import React, { useEffect } from "react";
import { useRef, useState } from "react";
import { Form, Button, Row, Col, Table } from "react-bootstrap";
import API_BASE_URL from "../../config";
import { authFetch } from "../../utility/authFetch";

function FollowUpSearch({ setLoader, setSearch, setId, name, url }) {
  const formRef = useRef();
  const [query, setQuery] = useState("");
  const [patientList, setPatientList] = useState([]);

  useEffect(() => {
    if (!query) {
      setPatientList([]);
      return;
    }

    const delayDebounce = setTimeout(() => {
      authFetch(`${API_BASE_URL}/api/${url}?query=${query}`)
        .then((res) => res.json())
        .then((data) => {
          setPatientList(data.patients);
        })
        .catch((err) => console.error("Error fetching:", err));
    }, 400);

    return () => clearTimeout(delayDebounce);
  }, [query]);

  return (
    <div className="p-4" style={{ backgroundColor: "#f8f9fa" }}>
      <div className="container bg-white p-4 rounded shadow-sm">
        <h5 className="mb-3">{name}</h5>

        <Form ref={formRef}>
          <Row className="align-items-end g-3">
            <Col md={12}>
              <Form.Group className="mb-3" controlId="formPatientName">
                <Form.Label>
                  Patient Name <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Patient Name"
                  name="name"
                  required
                  autoComplete="off"
                  list="patient-options"
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
        </Form>

        <Table striped bordered hover>
          <thead>
            <tr>
              <th style={{ width: "100px" }}>Action</th>
              <th>Name</th>
              <th>Contact Number</th>
            </tr>
          </thead>
          <tbody>
            {patientList.length === 0 ? (
              <tr>
                <td colSpan="3" className="text-center">
                  No records found
                </td>
              </tr>
            ) : (
              patientList.map((item, index) => (
                <tr key={index}>
                  <td>
                    <Button
                      variant="info"
                      onClick={() => {
                        setSearch(false);
                        setId(item.id);
                      }}
                    >
                      VIEW
                    </Button>
                  </td>
                  <td>{item.name}</td>
                  <td>{item.contact}</td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </div>
    </div>
  );
}

export default FollowUpSearch;
